export default __webpack_public_path__ + "static/media/error.ae9cb5ab.svg";